__turbopack_context__.v({
  "content": "yNwpPq_content",
  "innercontent": "yNwpPq_innercontent",
});
